<template>
  <div id="setting-component" class="hidden setting-component">
    <dialog-drag
      id="dialog-setting"
      class="dialog-setting"
      :title="$t('modal.setting.title')"
      :options="settingModalPos"
    >
      <ul class="cards dialog-setting-cards">
        <li class="cards__item dialog-setting-cards__item">
          <div class="card dialog-setting-card" @click="openLayers">
            <div
              class="card__image card__image--layers dialog-setting-card__image dialog-setting-card__image--layers"
            ></div>
            <div class="card__content dialog-setting-card__content">
              <div class="card__title dialog-setting-card__title">
                {{ $t('modal.setting.layers') }}
              </div>
              <div class="card__arrow dialog-setting-card__arrow" v-show="!openedLayers">
                <i class="gjs-caret-icon fa fa-caret-down"></i>
              </div>
              <div class="card__arrow dialog-setting-card__arrow" v-show="openedLayers">
                <i class="gjs-caret-icon fa fa-caret-up"></i>
              </div>
            </div>
          </div>
          <ul id="dialog-layers" class="cards dialog-layers-cards" v-show="openedLayers">
            <li
              class="cards__item dialog-layers-cards__item"
              v-on:click="updatePositionLayers('first')"
            >
              <div class="card dialog-layers-card">
                <div
                  class="card__image card__image--fence dialog-layers-card__image dialog-layers-card__image--fence"
                ></div>
                <div class="card__content">
                  <div class="card__title ">{{ $t('labels.Foreground') }}</div>
                </div>
              </div>
            </li>
            <li class="cards__item" v-on:click="updatePositionLayers('move')">
              <div class="card dialog-layers-card">
                <div
                  class="card__image card__image--river dialog-layers-card__image dialog-layers-card__image--river"
                ></div>
                <div class="card__content">
                  <div class="card__title">{{ $t('labels.advance_more') }}</div>
                </div>
              </div>
            </li>
            <li class="cards__item" v-on:click="updatePositionLayers('last')">
              <div class="card dialog-layers-card">
                <div
                  class="card__image card__image--record dialog-layers-card__image dialog-layers-card__image--record"
                ></div>
                <div class="card__content">
                  <div class="card__title">{{ $t('labels.background') }}</div>
                </div>
              </div>
            </li>
            <li class="cards__item" v-on:click="updatePositionLayers('back')">
              <div class="card dialog-layers-card">
                <div
                  class="card__image card__image--flowers dialog-layers-card__image dialog-layers-card__image--flowers"
                ></div>
                <div class="card__content">
                  <div class="card__title">{{ $t('labels.Recede_less') }}</div>
                </div>
              </div>
            </li>
          </ul>
        </li>
        <li
          class="cards__item dialog-setting-cards__item"
          v-has-permission="'animate_components_action'"
        >
          <div class="card dialog-setting-card" @click="openAnimation">
            <div
              class="card__image card__image--effects dialog-setting-card__image dialog-setting-card__image--effects"
            ></div>
            <div class="card__content dialog-setting-card__content">
              <div class="card__title dialog-setting-card__title">
                {{ $t('modal.setting.effects') }}
              </div>
              <div class="card__arrow dialog-setting-card__arrow" v-show="!openedAnimation">
                <i class="gjs-caret-icon fa fa-caret-down"></i>
              </div>
              <div class="card__arrow dialog-setting-card__arrow" v-show="openedAnimation">
                <i class="gjs-caret-icon fa fa-caret-up"></i>
              </div>
            </div>
          </div>
          <ul id="dialog-animation" class="cards dialog-animation-cards" v-show="openedAnimation">
            <li class="cards__item" style="width: 100%;">
              <div
                class="card dialog-animation-card"
                style="padding: 38px;"
                @click="updateClassElement('none')"
                :class="{ selected: currentAnimation === 'none' }"
              >
                <div class="card__image  dialog-animation-card__image ">
                  <b>{{ $t('modal.setting.animation.without_animation') }}</b>
                </div>
              </div>
            </li>
            <li class="cards__item">
              <div
                class="card dialog-animation-card"
                v-on:click="updateClassElement('grow')"
                :class="{ selected: currentAnimation === 'grow' }"
              >
                <div class="card__image  dialog-animation-card__image">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="130px"
                    height="100px"
                    viewBox="0 0 130 100"
                    enable-background="new 0 0 130 100"
                    xml:space="preserve"
                    style="width: 100%;"
                    class="animations"
                  >
                    <linearGradient
                      id="SVGID_1_"
                      gradientUnits="userSpaceOnUse"
                      x1="50"
                      y1="50"
                      x2="5.3714"
                      y2="50"
                    >
                      <!--123.8933-->
                      <stop offset="0.1603" style="stop-color:#E7EAED"></stop>
                      <stop offset="0.5137" style="stop-color:#2196F3"></stop>
                      <stop offset="0.7115" style="stop-color:#ACD1EF"></stop>
                      <stop offset="0.7853" style="stop-color:#C1DAEE"></stop>
                      <stop offset="0.8205" style="stop-color:#CEDFEE"></stop>
                      <stop offset="0.8654" style="stop-color:#E7EAED"></stop>
                    </linearGradient>
                    <path
                      fill="url(#SVGID_1_)"
                      d="M114.203,5.367H89.5h-49H15.797c-5.555,0-10.058,4.503-10.058,10.058v69.15
	c0,5.555,4.503,10.058,10.058,10.058H40.5h49h24.703c5.555,0,10.058-4.503,10.058-10.058v-69.15
	C124.261,9.87,119.758,5.367,114.203,5.367z"
                    ></path>
                    <g class="split-right" fill="#01527F">
                      <path
                        d="M114.239 49.999c0-.194-.075-.365-.224-.515l-10.438-10.438c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515L110.229 50l-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z"
                      ></path>
                      <path
                        d="M106.49 49.999c0-.194-.075-.365-.224-.515L95.828 39.045c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515L102.48 50l-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z"
                        opacity=".9"
                      ></path>
                      <path
                        d="M97.774 49.999c0-.194-.075-.365-.224-.515L87.112 39.046c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515L93.764 50l-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z"
                        opacity=".6"
                      ></path>
                    </g>
                    <g class="split-left" fill="#01527F">
                      <path
                        d="M20.256 50.001c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515L24.266 50l8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L20.481 49.484c-.15.153-.225.323-.225.517z"
                      ></path>
                      <path
                        d="M28.005 50.001c0 .194.075.365.224.515l10.438 10.439c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515L32.015 50l8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L28.23 49.484c-.15.153-.225.323-.225.517z"
                        opacity=".9"
                      ></path>
                      <path
                        d="M36.721 50.001c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515L40.731 50l8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L36.946 49.484c-.15.153-.225.323-.225.517z"
                        opacity=".6"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div class="card__content">
                  <div class="card__title">{{ $t('modal.setting.animation.grow') }}</div>
                </div>
              </div>
            </li>
            <li class="cards__item">
              <div
                class="card dialog-animation-card"
                v-on:click="updateClassElement('fade-in')"
                :class="{ selected: currentAnimation === 'fade-in' }"
              >
                <div class="card__image  dialog-animation-card__image ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="130px"
                    height="100px"
                    viewBox="0 0 130 100"
                    enable-background="new 0 0 130 100"
                    xml:space="preserve"
                    style="width: 100%;"
                    class="animations"
                  >
                    <linearGradient
                      id="a"
                      x1="-843.86"
                      x2="-735.14"
                      y1="-1765.76"
                      y2="-1765.76"
                      gradientTransform="translate(869.97 1815.33)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset=".15" stop-color="#ededed"></stop>
                      <stop offset=".28" stop-color="#eaeced"></stop>
                      <stop offset=".38" stop-color="#e0e8ed"></stop>
                      <stop offset=".47" stop-color="#d0e1ee"></stop>
                      <stop offset=".55" stop-color="#b9d7ef"></stop>
                      <stop offset=".63" stop-color="#9ccbf0"></stop>
                      <stop offset=".65" stop-color="#95c8f0"></stop>
                      <stop offset=".71" stop-color="#92c7f0"></stop>
                      <stop offset=".76" stop-color="#8ac3f0"></stop>
                      <stop offset=".79" stop-color="#7bbdf1"></stop>
                      <stop offset=".82" stop-color="#65b3f1"></stop>
                      <stop offset=".85" stop-color="#4aa8f2"></stop>
                      <stop offset=".86" stop-color="#42a4f2"></stop>
                      <stop offset=".98" stop-color="#2196f3"></stop>
                    </linearGradient>
                    <path
                      fill="url(#a)"
                      d="M124.75 84.1c0 5.54-4.5 10.04-10.04 10.04H16.44c-5.54 0-10.04-4.5-10.04-10.04V15.04C6.4 9.5 10.9 5 16.44 5h98.27c5.55 0 10.04 4.5 10.04 10.04V84.1z"
                    ></path>
                    <path
                      class="wipe"
                      fill="#01527F"
                      d="M57.915 49.593c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L58.14 49.076c-.15.153-.225.323-.225.517z"
                    ></path>
                    <path
                      class="wipe"
                      fill="#01527F"
                      d="M65.664 49.593c0 .194.075.365.224.515l10.438 10.439c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.804 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L65.889 49.076c-.15.153-.225.323-.225.517z"
                      opacity=".9"
                    ></path>
                    <path
                      class="wipe"
                      fill="#01527F"
                      d="M74.38 49.593c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L74.605 49.076c-.15.153-.225.323-.225.517z"
                      opacity=".6"
                    ></path>
                  </svg>
                </div>
                <div class="card__content">
                  <div class="card__title">{{ $t('modal.setting.animation.fade-in') }}</div>
                </div>
              </div>
            </li>
            <li class="cards__item">
              <div
                class="card dialog-animation-card"
                v-on:click="updateClassElement('fade-up')"
                :class="{ selected: currentAnimation === 'fade-up' }"
              >
                <div class="card__image  dialog-animation-card__image  ">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="130px"
                    height="100px"
                    viewBox="0 0 130 100"
                    enable-background="new 0 0 130 100"
                    xml:space="preserve"
                    style="width: 100%;"
                    class="animations"
                  >
                    <linearGradient
                      id="SVGID_1_"
                      gradientUnits="userSpaceOnUse"
                      x1="-5737.2393"
                      y1="-2156.1602"
                      x2="-5737.2393"
                      y2="-2245.2402"
                      gradientTransform="matrix(1 0 0 1 5802.2344 2236.4221)"
                    >
                      <stop offset="0.3976" style="stop-color:#EDEDED"></stop>
                      <stop offset="0.4897" style="stop-color:#E9EBED"></stop>
                      <stop offset="0.5724" style="stop-color:#DFE7ED"></stop>
                      <stop offset="0.6514" style="stop-color:#CCDFEE"></stop>
                      <stop offset="0.7282" style="stop-color:#B2D4EF"></stop>
                      <stop offset="0.8034" style="stop-color:#91C6F0"></stop>
                      <stop offset="0.8774" style="stop-color:#68B4F1"></stop>
                      <stop offset="0.9491" style="stop-color:#39A0F2"></stop>
                      <stop offset="0.9817" style="stop-color:#2196F3"></stop>
                    </linearGradient>
                    <path
                      fill="url(#SVGID_1_)"
                      d="M124.132,85.057c0,5.543-4.494,10.037-10.037,10.037H15.895c-5.544,0-10.037-4.494-10.037-10.037
	l0-69.006c0-5.543,4.494-10.037,10.037-10.037h98.201c5.543,0,10.037,4.494,10.037,10.037V85.057L124.132,85.057z"
                    ></path>
                    <path
                      class="to-the-top"
                      id="_x3C_Path3_x3E__1_"
                      fill="#01527F"
                      d="M64.999,13.917c-0.174,0-0.328,0.067-0.463,0.201l-9.377,9.377
	c-0.135,0.135-0.201,0.288-0.201,0.463c0,0.174,0.068,0.328,0.201,0.463l1.007,1.007c0.135,0.135,0.288,0.201,0.463,0.201
	c0.174,0,0.328-0.067,0.463-0.201L65,17.519l7.909,7.909c0.135,0.135,0.288,0.201,0.463,0.201c0.174,0,0.33-0.067,0.463-0.201
	l1.007-1.007c0.135-0.135,0.201-0.288,0.201-0.463c0-0.174-0.067-0.328-0.201-0.463l-9.377-9.377
	C65.327,13.984,65.173,13.917,64.999,13.917z"
                    ></path>
                    <path
                      class="to-the-top"
                      id="_x3C_Path2_x3E_"
                      opacity="0.9"
                      fill="#01527F"
                      enable-background="new    "
                      d="M64.999,20.878
	c-0.174,0-0.328,0.067-0.463,0.201l-9.377,9.377c-0.135,0.135-0.201,0.288-0.201,0.463c0,0.174,0.068,0.328,0.201,0.463l1.007,1.007
	c0.135,0.135,0.288,0.201,0.463,0.201c0.174,0,0.328-0.067,0.463-0.201L65,24.48l7.909,7.909c0.135,0.135,0.288,0.201,0.463,0.201
	c0.174,0,0.33-0.067,0.463-0.201l1.007-1.007c0.135-0.135,0.201-0.288,0.201-0.463c0-0.174-0.067-0.328-0.201-0.463l-9.377-9.377
	C65.327,20.945,65.173,20.878,64.999,20.878z"
                    ></path>
                    <path
                      class="to-the-top"
                      id="_x3C_Path1_x3E__2_"
                      opacity="0.6"
                      fill="#01527F"
                      enable-background="new    "
                      d="M64.999,28.708
	c-0.174,0-0.328,0.067-0.463,0.201l-9.377,9.377c-0.135,0.135-0.201,0.288-0.201,0.463c0,0.174,0.068,0.328,0.201,0.463l1.007,1.007
	c0.135,0.135,0.288,0.201,0.463,0.201c0.174,0,0.328-0.067,0.463-0.201L65,32.31l7.909,7.909c0.135,0.135,0.288,0.201,0.463,0.201
	c0.174,0,0.33-0.067,0.463-0.201l1.007-1.007c0.135-0.135,0.201-0.288,0.201-0.463c0-0.174-0.067-0.328-0.201-0.463l-9.377-9.377
	C65.327,28.775,65.173,28.708,64.999,28.708z"
                    ></path>
                    <linearGradient
                      id="SVGID_2_"
                      gradientUnits="userSpaceOnUse"
                      x1="-2475.406"
                      y1="-1137.0306"
                      x2="-2475.406"
                      y2="-1184.0306"
                      gradientTransform="matrix(-1 0 0 1 -2410.4109 1232.1246)"
                    >
                      <stop offset="0.0092" style="stop-color:#418AC6"></stop>
                      <stop offset="0.3523" style="stop-color:#3190DD"></stop>
                      <stop offset="0.7102" style="stop-color:#2594ED"></stop>
                      <stop offset="0.9817" style="stop-color:#2196F3"></stop>
                    </linearGradient>
                    <path
                      fill="url(#SVGID_2_)"
                      d="M5.968,86.093v-27.41c0-5.55,4.614-10.589,10.154-10.589h36.846v6.199
	c0,3.13,2.314,4.801,5.444,4.801h13.36c3.13,0,5.196-1.671,5.196-4.801v-6.199h37.094c5.54,0,9.906,5.039,9.906,10.589v27.411h0.054
	c-0.6,5-4.83,9-9.96,9h-97.94c-5.13,0-9.36-4-9.96-9L5.968,86.093L5.968,86.093z"
                    ></path>
                  </svg>
                </div>
                <div class="card__content">
                  <div class="card__title">{{ $t('modal.setting.animation.fade-up') }}</div>
                </div>
              </div>
            </li>
            <li class="cards__item">
              <div
                class="card dialog-animation-card"
                v-on:click="updateClassElement('fade-down')"
                :class="{ selected: currentAnimation === 'fade-down' }"
              >
                <div class="card__image  dialog-animation-card__image ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="130px"
                    height="100px"
                    viewBox="0 0 130 100"
                    enable-background="new 0 0 130 100"
                    xml:space="preserve"
                    style="width: 100%;"
                    class="animations"
                  >
                    <linearGradient
                      id="a"
                      x1="-1887.4"
                      x2="-1887.4"
                      y1="1251.16"
                      y2="1340.24"
                      gradientTransform="matrix(-1 0 0 1 -1822.43 -1230.31)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset=".4" stop-color="#ededed"></stop>
                      <stop offset=".49" stop-color="#e9ebed"></stop>
                      <stop offset=".57" stop-color="#dfe7ed"></stop>
                      <stop offset=".65" stop-color="#ccdfee"></stop>
                      <stop offset=".73" stop-color="#b2d4ef"></stop>
                      <stop offset=".8" stop-color="#91c6f0"></stop>
                      <stop offset=".88" stop-color="#68b4f1"></stop>
                      <stop offset=".95" stop-color="#39a0f2"></stop>
                      <stop offset=".98" stop-color="#2196f3"></stop>
                    </linearGradient>
                    <path
                      fill="url(#a)"
                      d="M5.83 16.05c0-5.54 4.5-10.04 10.04-10.04h98.2c5.54 0 10.03 4.5 10.03 10.04v69c0 5.55-4.49 10.04-10.03 10.04h-98.2c-5.55 0-10.04-4.49-10.04-10.03v-69z"
                    ></path>
                    <linearGradient
                      id="b"
                      x1="64.87"
                      x2="64.87"
                      y1="6.32"
                      y2="53.32"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset=".01" stop-color="#418ac6"></stop>
                      <stop offset=".35" stop-color="#3190dd"></stop>
                      <stop offset=".71" stop-color="#2594ed"></stop>
                      <stop offset=".98" stop-color="#2196f3"></stop>
                    </linearGradient>
                    <path
                      fill="url(#b)"
                      d="M123.8 15.31V42.2c0 5.55-4.29 11.13-9.83 11.13H76.81v-6.74c0-3.13-2-4.26-5.13-4.26H58.32c-3.13 0-5.51 1.13-5.51 4.26v6.74H16.03c-5.54 0-10.22-5.58-10.22-11.13V15.31h.26c.6-5 4.83-9 9.96-9h97.94c5.13 0 9.36 4 9.96 9h-.12z"
                    ></path>
                    <path
                      class="down"
                      fill="#01527F"
                      d="M65.002 86.191c.194 0 .365-.075.515-.224l10.438-10.438c.15-.15.224-.321.224-.515s-.076-.365-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224l-8.803 8.803-8.804-8.804c-.15-.15-.321-.224-.515-.224s-.367.075-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l10.438 10.438c.153.15.324.225.518.225z"
                    ></path>
                    <path
                      class="down"
                      fill="#01527F"
                      d="M65.001 78.442c.194 0 .365-.075.515-.224L75.955 67.78c.15-.15.224-.321.224-.515s-.076-.365-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L65 74.432l-8.804-8.804c-.15-.15-.321-.224-.515-.224s-.367.075-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l10.438 10.438c.153.15.324.225.518.225z"
                      opacity=".9"
                    ></path>
                    <path
                      class="down"
                      fill="#01527F"
                      d="M65.002 69.726c.194 0 .365-.075.515-.224l10.438-10.438c.15-.15.224-.321.224-.515s-.076-.365-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224l-8.803 8.803-8.804-8.804c-.15-.15-.321-.224-.515-.224s-.367.075-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l10.438 10.438c.153.15.324.225.518.225z"
                      opacity=".6"
                    ></path>
                  </svg>
                </div>
                <div class="card__content">
                  <div class="card__title">{{ $t('modal.setting.animation.fade-down') }}</div>
                </div>
              </div>
            </li>
            <li class="cards__item">
              <div
                class="card dialog-animation-card"
                v-on:click="updateClassElement('fade-left')"
                :class="{ selected: currentAnimation === 'fade-left' }"
              >
                <div class="card__image  dialog-animation-card__image ">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="130px"
                    height="100px"
                    viewBox="0 0 130 100"
                    enable-background="new 0 0 130 100"
                    xml:space="preserve"
                    style="width: 100%;"
                    class="animations"
                  >
                    <linearGradient
                      id="SVGID_1_"
                      gradientUnits="userSpaceOnUse"
                      x1="1093.7883"
                      y1="1849.1655"
                      x2="1212.7463"
                      y2="1849.1655"
                      gradientTransform="matrix(-1 0 0 1 1196.7474 -1800.0706)"
                    >
                      <stop offset="0.1476" style="stop-color:#EDEDED"></stop>
                      <stop offset="0.2811" style="stop-color:#EAECED"></stop>
                      <stop offset="0.3813" style="stop-color:#E0E8ED"></stop>
                      <stop offset="0.4706" style="stop-color:#D0E1EE"></stop>
                      <stop offset="0.5536" style="stop-color:#B9D7EF"></stop>
                      <stop offset="0.6315" style="stop-color:#9CCBF0"></stop>
                      <stop offset="0.6483" style="stop-color:#95C8F0"></stop>
                      <stop offset="0.7129" style="stop-color:#92C7F0"></stop>
                      <stop offset="0.7553" style="stop-color:#8AC3F0"></stop>
                      <stop offset="0.7911" style="stop-color:#7BBDF1"></stop>
                      <stop offset="0.8235" style="stop-color:#65B3F1"></stop>
                      <stop offset="0.8531" style="stop-color:#4AA8F2"></stop>
                      <stop offset="0.8609" style="stop-color:#42A4F2"></stop>
                      <stop offset="0.9817" style="stop-color:#2196F3"></stop>
                    </linearGradient>
                    <path
                      fill="url(#SVGID_1_)"
                      d="M3.808,14.392c0-5.576,4.52-10.095,10.095-10.095h98.768c5.576,0,10.095,4.52,10.095,10.095v69.405
	c0,5.575-4.52,10.095-10.095,10.095H13.903c-5.576,0-10.095-4.52-10.095-10.095V14.392L3.808,14.392z"
                    ></path>
                    <linearGradient
                      id="SVGID_2_"
                      gradientUnits="userSpaceOnUse"
                      x1="-1766.7854"
                      y1="-1182.8807"
                      x2="-1706.7854"
                      y2="-1182.8807"
                      gradientTransform="matrix(1 0 0 -1 1829.9474 -1133.5135)"
                    >
                      <stop offset="0.0092" style="stop-color:#418AC6"></stop>
                      <stop offset="0.3523" style="stop-color:#3190DD"></stop>
                      <stop offset="0.7102" style="stop-color:#2594ED"></stop>
                      <stop offset="0.9817" style="stop-color:#2196F3"></stop>
                    </linearGradient>
                    <path
                      fill="url(#SVGID_2_)"
                      d="M123.162,14.431v70.033c0,4.895-3.669,8.831-8.257,9.815c-0.691,0.152-1.636,0.079-2.372,0.079H72.58
	c-5.322,0-8.418-3.798-9.418-9.024V61.358h5.185c3.184,0,6.815-1.708,6.815-4.895V42.779c0-3.187-3.631-6.421-6.815-6.421h-5.185
	V13.561c1-5.226,4.096-9.203,9.42-9.203h39.95c0.737,0,1.678,0.017,2.37,0.169C119.49,5.51,123.162,9.533,123.162,14.431z"
                    ></path>
                    <path
                      class="to-the-left"
                      fill="#01527F"
                      d="M29.911 49.093c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L30.136 48.576c-.15.153-.225.323-.225.517z"
                    ></path>
                    <path
                      class="to-the-left"
                      fill="#01527F"
                      d="M37.66 49.093c0 .194.075.365.224.515l10.438 10.439c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.804 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L37.885 48.576c-.15.153-.225.323-.225.517z"
                      opacity=".9"
                    ></path>
                    <path
                      class="to-the-left"
                      fill="#01527F"
                      d="M46.376 49.093c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L46.601 48.576c-.15.153-.225.323-.225.517z"
                      opacity=".6"
                    ></path>
                    <linearGradient
                      id="SVGID_3_"
                      gradientUnits="userSpaceOnUse"
                      x1="-45.826"
                      y1="74.554"
                      x2="-45.826"
                      y2="74.554"
                      gradientTransform="matrix(-1 0 0 1 67.93 15.2735)"
                    >
                      <stop offset="0.0092" style="stop-color:#418AC6"></stop>
                      <stop offset="0.3523" style="stop-color:#3190DD"></stop>
                      <stop offset="0.7102" style="stop-color:#2594ED"></stop>
                      <stop offset="0.9817" style="stop-color:#2196F3"></stop>
                    </linearGradient>
                    <path fill="url(#SVGID_3_)" d="M113.756,89.827"></path>
                  </svg>
                </div>
                <div class="card__content">
                  <div class="card__title">{{ $t('modal.setting.animation.fade-left') }}</div>
                </div>
              </div>
            </li>
            <li class="cards__item">
              <div
                class="card dialog-animation-card"
                v-on:click="updateClassElement('fade-right')"
                :class="{ selected: currentAnimation === 'fade-right' }"
              >
                <div class="card__image  dialog-animation-card__image ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="130px"
                    height="100px"
                    viewBox="0 0 130 100"
                    enable-background="new 0 0 130 100"
                    xml:space="preserve"
                    style="width: 100%;"
                    class="animations"
                  >
                    <linearGradient
                      id="a"
                      x1="1152.83"
                      x2="1271.79"
                      y1="-1765.77"
                      y2="-1765.77"
                      gradientTransform="translate(-1128.82 1815.34)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset=".15" stop-color="#ededed"></stop>
                      <stop offset=".28" stop-color="#eaeced"></stop>
                      <stop offset=".38" stop-color="#e0e8ed"></stop>
                      <stop offset=".47" stop-color="#d0e1ee"></stop>
                      <stop offset=".55" stop-color="#b9d7ef"></stop>
                      <stop offset=".63" stop-color="#9ccbf0"></stop>
                      <stop offset=".65" stop-color="#95c8f0"></stop>
                      <stop offset=".71" stop-color="#92c7f0"></stop>
                      <stop offset=".76" stop-color="#8ac3f0"></stop>
                      <stop offset=".79" stop-color="#7bbdf1"></stop>
                      <stop offset=".82" stop-color="#65b3f1"></stop>
                      <stop offset=".85" stop-color="#4aa8f2"></stop>
                      <stop offset=".86" stop-color="#42a4f2"></stop>
                      <stop offset=".98" stop-color="#2196f3"></stop>
                    </linearGradient>
                    <path
                      fill="url(#a)"
                      d="M123.16 84.28a10.1 10.1 0 0 1-10.1 10.1H14.3a10.1 10.1 0 0 1-10.1-10.1v-69.4a10.1 10.1 0 0 1 10.1-10.1h98.77a10.1 10.1 0 0 1 10.1 10.1v69.4z"
                    ></path>
                    <linearGradient
                      id="b"
                      x1="-996.83"
                      x2="-936.83"
                      y1="1760.48"
                      y2="1760.48"
                      gradientTransform="rotate(180 -466.5 904.9)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset=".01" stop-color="#418ac6"></stop>
                      <stop offset=".35" stop-color="#3190dd"></stop>
                      <stop offset=".71" stop-color="#2594ed"></stop>
                      <stop offset=".98" stop-color="#2196f3"></stop>
                    </linearGradient>
                    <path
                      fill="url(#b)"
                      d="M3.8 84.24V14.21c0-4.9 3.68-8.83 8.27-9.82.69-.15 1.63-.07 2.37-.07h39.95c5.32 0 8.42 3.8 9.42 9.02v23.98h-5.19c-3.18 0-6.81 1.7-6.81 4.89v13.68c0 3.2 3.63 6.42 6.81 6.42h5.19v22.8c-1 5.23-4.1 9.2-9.42 9.2H14.44c-.74 0-1.68-.01-2.37-.16-4.59-.99-8.26-5.01-8.26-9.9z"
                    ></path>
                    <path
                      class="to-the-right"
                      fill="#01527F"
                      d="M97.705 49.549c0-.194-.075-.365-.224-.515L87.043 38.596c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l8.803 8.803-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224L97.48 50.066c.15-.153.225-.323.225-.517z"
                    ></path>
                    <path
                      class="to-the-right"
                      fill="#01527F"
                      d="M89.956 49.549c0-.194-.075-.365-.224-.515L79.294 38.595c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l8.803 8.804-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z"
                      opacity=".9"
                    ></path>
                    <path
                      class="to-the-right"
                      fill="#01527F"
                      d="M81.24 49.549c0-.194-.075-.365-.224-.515L70.578 38.596c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l8.803 8.803-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z"
                      opacity=".6"
                    ></path>
                    <linearGradient
                      id="c"
                      x1="13.21"
                      x2="13.21"
                      y1="8.85"
                      y2="8.85"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset=".01" stop-color="#418ac6"></stop>
                      <stop offset=".35" stop-color="#3190dd"></stop>
                      <stop offset=".71" stop-color="#2594ed"></stop>
                      <stop offset=".98" stop-color="#2196f3"></stop>
                    </linearGradient>
                  </svg>
                </div>
                <div class="card__content">
                  <div class="card__title">{{ $t('modal.setting.animation.fade-right') }}</div>
                </div>
              </div>
            </li>
          </ul>
          <ul
            id="dialog-animation-duration"
            class="cards dialog-animation-duration-cards"
            v-show="openedAnimation"
          >
            <input
              id="delay-element"
              class="form-group delay-element"
              :placeholder="$t('modal.setting.delay')"
              @change="setDelayElement($event)"
              @focus="toggleModalDraggable('false')"
              @blur="toggleModalDraggable('true')"
              v-model="delayValue"
            />
          </ul>
          <ul
            id="dialog-text-animation"
            class="cards dialog-text-animation-cards"
            v-show="openedAnimation"
          >
            <li class="cards__item dialog-text-animation-cards__item" v-if="isComponentText">
              <div
                class="card dialog-text-animation-card"
                v-on:click="updateClassElement('strike')"
                :class="{ selected: currentAnimation === 'strike' }"
              >
                <div
                  class="card__text-animations  dialog-text-animation-card__image dialog-text-animation-card__scale"
                >
                  <div id="animation-strike" class="text-animation-preview">
                    <span
                      class="text-animation-preview__sample text-animation-preview__sample--strike"
                      >Abc</span
                    >
                  </div>
                </div>
                <div class="card__content">
                  <div class="card__title">{{ $t('modal.setting.animation.strike') }}</div>
                </div>
              </div>
            </li>
            <li class="cards__item dialog-text-animation-cards__item" v-if="isComponentText">
              <div
                class="card dialog-text-animation-card"
                v-on:click="updateClassElement('reveal-text')"
                :class="{ selected: currentAnimation === 'reveal-text' }"
              >
                <div
                  class="card__text-animations  dialog-text-animation-card__image dialog-text-animation-card__scale"
                >
                  <div id="animation-reveal-text" class="text-animation-preview">
                    <span
                      class="text-animation-preview__sample text-animation-preview__sample--reveal"
                      >Abc</span
                    >
                  </div>
                </div>
                <div class="card__content">
                  <div class="card__title">{{ $t('modal.setting.animation.reveal-text') }}</div>
                </div>
              </div>
            </li>
          </ul>
        </li>
        <li class="cards__item dialog-setting-cards__item">
          <div class="card dialog-setting-card" @click="openOpacity">
            <div
              class="card__image card__image--opacity dialog-setting-card__image dialog-setting-card__image--opacity"
            ></div>
            <div class="card__content dialog-setting-card__content">
              <div class="card__title dialog-setting-card__title">
                {{ $t('modal.setting.opacity') }}
              </div>
              <div class="card__arrow dialog-setting-card__arrow" v-show="!openedOpacity">
                <i class="gjs-caret-icon fa fa-caret-down"></i>
              </div>
              <div class="card__arrow dialog-setting-card__arrow" v-show="openedOpacity">
                <i class="gjs-caret-icon fa fa-caret-up"></i>
              </div>
            </div>
          </div>
          <div
            id="dialog-opacity"
            :title="$t('modal.setting.opacity')"
            v-show="openedOpacity"
            class="opacity-container"
          >
            <div class="opacity-container__range">
              <range-slider
                class="slider"
                min="0"
                max="100"
                step="1"
                v-model="sliderValue"
                @input="changeOpacity($event)"
                @change="displayOverlay"
              >
              </range-slider>
              <span class="slider-value">{{ sliderValue }}%</span>
            </div>
          </div>
        </li>
      </ul>
    </dialog-drag>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DialogDrag from 'vue-dialog-drag';
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
import RangeSlider from 'vue-range-slider';
import 'vue-range-slider/dist/vue-range-slider.css';
import mixinGrapes from '../../mixins/GrapesMixinAnimation.js';
import HasPermission from '../../core/directives/HasPermission.js';
import mixin from '../../mixins/Mixin.js';

export default {
  name: 'SettingComponent',
  mixins: [mixin, mixinGrapes],
  directives: {
    HasPermission,
  },
  data() {
    return {
      isComponentText: false,
      openedAnimation: false,
      openedOpacity: false,
      openedLayers: false,
      sliderValue: 100,
      opacityValue: 1,
      initClass: [
        'fragment',
        'grow',
        'fade-in',
        'fade-up',
        'fade-down',
        'fade-left',
        'fade-right',
        'shrink',
        'fade-out',
        'delay',
        'reveal-text',
        'strike',
      ],
      delayValue: '',
      index: 1,
    };
  },
  components: {
    DialogDrag,
    SweetModal,
    SweetModalTab,
    RangeSlider,
  },
  computed: {
    ...mapGetters({
      settingModalPos: 'common/getSettingModalPos',
      getDelayFragment: 'slides/getDelayFragment',
      getOpacityFragment: 'slides/getOpacityFragment',
    }),
    currentAnimation() {
      if (!window.grapesjsEMP && this.index) {
        return 'none';
      }
      const editor = window.grapesjsEMP.editors[0];
      const model = editor.getSelected();

      const animation = model ? model.getEl().getAttribute('data-animation') : null;
      return this.index && animation ? animation.replace('fragment ', '') : 'none';
    },
  },

  methods: {
    ...mapActions('slides', ['setOpacityFragment']),

    updateLayers(zIndex) {
      let self = this;
      let newCurrentZIndex = 0;
      let oldCurrentZIndex = this.getZIndexCurrentSlide();
      switch (zIndex) {
        case 'max':
          newCurrentZIndex = self.getAllComponets().length;
          break;
        case 'min':
          newCurrentZIndex = 0;
          break;
        case -1:
          oldCurrentZIndex--;
          break;
        default:
          oldCurrentZIndex++;
      }
      this.removeStyleClassElement('emp-z-index-');
      this.addStyleClassElement({ 'z-index': newCurrentZIndex }, 'emp-z-index-' + newCurrentZIndex);
    },
    updatePositionLayers(position) {
      const editor = grapesjsEMP.editors[0];
      const cssComposer = editor.CssComposer;
      const models = editor.DomComponents.getComponents().models;
      const model = editor.getSelected();
      const id = model.getId();
      const c = model.getClasses()[0];
      const oldStyle = cssComposer.getClassRule(c).attributes.style;

      let index = parseInt(oldStyle['z-index']);

      const firstLayer = models.length;

      let newIndex = 0;
      switch (position) {
        case 'back':
          newIndex = Math.max(index - 1, 0);
          break;
        case 'move':
          newIndex = Math.min(index + 1, firstLayer);
          break;
        case 'first':
          newIndex = firstLayer;
          break;
      }

      let newStyle = Object.assign({}, oldStyle, { 'z-index': newIndex });
      cssComposer.setClassRule(c, newStyle);
    },
    openAnimation() {
      this.index++;
      this.openedAnimation = !this.openedAnimation;
      this.openedOpacity = false;
      this.openedLayers = false;
    },
    openOpacity() {
      var dialogSetting = document.getElementById('dialog-setting');
      var dialogOpacity = document.getElementById('dialog-opacity');

      this.openedOpacity = !this.openedOpacity;
      this.openedAnimation = false;
      this.openedLayers = false;
    },
    openLayers() {
      var dialogSetting = document.getElementById('dialog-setting');
      var dialogLayers = document.getElementById('dialog-layers');

      this.openedLayers = !this.openedLayers;
      this.openedAnimation = false;
      this.openedOpacity = false;
    },
    setDelayElement: function(event) {
      this.updateDelayGrapesElement(event.target.value);
      this.delayValue = event.target.value;
    },
    toggleModalDraggable(isDraggable) {
      document.getElementById('dialog-setting').setAttribute('draggable', isDraggable);
    },
    setDelayValue(delay) {
      this.delayValue = delay;
    },
    updateClassElement: function(classElement) {
      this.index++;
      this.updateClassGrapesElement(classElement, this.initClass);
    },
    changeOpacity(event) {
      this.updateStyleClassElement({ opacity: event / 100 }, 'classOpacity');

      this.sliderValue = event;
      document.querySelector('.setting-component').style.position = 'inherit';
    },
    displayOverlay() {
      document.querySelector('.setting-component').style.position = 'absolute';
    },
    setOpacityValue(opacity) {
      this.sliderValue = opacity;
    },
  },
  mounted() {
    const btnCloseSetting = document.querySelector('#dialog-setting button.close');
    btnCloseSetting.addEventListener('click', function() {
      const modelSetting = document.querySelector('#setting-component');
      modelSetting.classList.toggle('hidden');
      const selected = grapesjsEMP.editors[0].getSelected();
      let animation = grapesjsEMP.editors[0].getSelected().getAttributes();
      if (animation['data-animation']) {
        animation['animation'] = 'end ' + animation['data-animation'];
      } else {
        animation['animation'] = 'end';
      }
      selected.setAttributes(animation);
    });
    this.$root.$on('change-opacity', opacity => {
      this.setOpacityValue(opacity);
    });
    this.$root.$on('change-delay', delay => {
      this.setDelayValue(delay);
    });
  },
  created() {
    this.$root.$on('add-text-animation', isVisible => {
      this.isComponentText = isVisible;
    });
  },
};
</script>

<style lang="scss">
@import '../../scss/setting_composant';
.delay-element {
  display: none;
}

.dialog-animation-card.selected {
  background-color: #f0f3f6 !important;
  border-radius: 5px !important;
}

/* Aperçus des animations de texte (Barré / Révélation).
   Sans ces règles les cartes s'affichaient comme des cadres blancs vides. */
.dialog-text-animation-card {
  border: none !important;
}
.dialog-text-animation-card.selected {
  background-color: #f0f3f6 !important;
  border-radius: 5px !important;
}
.text-animation-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  border-radius: 5px;
  background-color: #eef1f5;
}
.text-animation-preview__sample {
  position: relative;
  display: inline-block;
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  color: #2196f3;
}
.text-animation-preview__sample--strike {
  text-decoration: line-through;
}
.text-animation-preview__sample--reveal::after {
  content: '';
  position: absolute;
  top: -2px;
  right: -3px;
  width: 50%;
  height: calc(100% + 4px);
  background-color: #2196f3;
}
</style>
<style src="vue-dialog-drag/dist/vue-dialog-drag.css"></style>



// WEBPACK FOOTER //
// SettingComponent.vue?2242b368